import React from 'react'
import LandingHeaderComponent from '../../components/Header/LandingHeaderComponent'
import Demographics from '../../components/Demographics/Demographics'
import BossMagicSection from '../../components/BossMagic/BossMagicSection'
import KeyFeatures from '../../components/KeyFeatures/KeyFeatures'
import Pricing from '../../components/Pricing/Pricing'
import ContactUs from '../../components/ContactUs'
import Footer from '../../components/Footer/Footer'
import FAQSection from '../../components/FAQ'
import { Outlet } from 'react-router-dom';

const LandingPage = () => {
  return (
    <div>
      <LandingHeaderComponent/>
    <Demographics/>
    <BossMagicSection/>
    <KeyFeatures/>
    <Pricing/><br/>
    <br/><br/>
    <br/><br/>
    <br/>
    <Outlet />
    <FAQSection/>
    <ContactUs/>
    <Footer/>
    </div>
    
  )
}

export default LandingPage